import { REGION } from '@ms/config/app'
import { getStorage } from '@ms/utils/storage'

// 设置本地缓存数据
export const setLocalData = (key, data, type) => {
  key = `${REGION}-${key}`
  if (type && type === 'session') sessionStorage.setItem(key, JSON.stringify(data))
  else localStorage.setItem(key, JSON.stringify(data))
}

// 获取本地缓存数据
export const getLocalData = (key, type) => getStorage(`${REGION}-${key}`, null, type)

/**
 * 获取 session storage 缓存
 * @param  {String} key                 缓存的 key
 * @param  {Object|Array} defaultValue  默认值
 * @return {Object|Array}
 */
export const getSessionData = (key, defaultValue = {}) => {
  try {
    const localData = sessionStorage.getItem(key)
    return localData ? JSON.parse(localData) : defaultValue
  } catch (error) {
    console.error(error)
    return defaultValue
  }
}
